import SkeletonLoader from "@/components/custom/SkeletonLoader";
import MarkdownPreview from "@uiw/react-markdown-preview";
import { ScrollArea } from "@/components/ui/scroll-area";

import { Bold, Image, Italic, Underline } from "lucide-react";

const BlogContentPreviewComponent = ({
  title,
  content,
  loading,
}: {
  title?: string;
  content: string;
  loading: boolean;
}) => {
  return (
    <div className="bg-[#3D82FE] p-4 rounded-[20px] shadow-border-layer min-h-[484px] mt-6 lg:mt-0 w-full">
      <div className="flex gap-2 m-2 mb-3">
        <div className="rounded-full  h-3 w-3 bg-[#5B95FE] opacity-60" />
        <div className="rounded-full h-3 w-3 bg-[#5B95FE] opacity-60" />
        <div className="rounded-full h-3 w-3 bg-[#5B95FE] opacity-60" />
      </div>
      <div className="flex justify-between mx-1  my-4">
        <div className="flex gap-3 justify-start">
                 <Bold size={25} className="opacity-20"/>
                 <Italic size={25} className="opacity-20"/>
                 <Underline size={25} className="opacity-20"/>
                 <div className="p-2 lg:w-[25px] h-[25px] px-[10px] rounded-[4px] bg-white opacity-40"></div>
                 <div className="p-2 lg:w-[25px] h-[25px] px-[10px] rounded-[4px] bg-white opacity-20"></div>



        </div>
        <div className="flex  gap-3 justify-end">
                 <div className="p-2 lg:w-[25px] h-[25px] px-[10px] rounded-[4px] bg-white opacity-20"></div>
<Image size={25} className="opacity-20"/>

        </div>
      </div>
        <hr className="opacity-20 m-2 my-4"/>


      {title && <h2 className="text-4xl my-6">Title: {title}</h2>}
      {loading && (
        <ScrollArea className="h-[70vh] w-full">
          <SkeletonLoader />
        </ScrollArea>
      )}
      {!loading && (
        <ScrollArea className="h-[70vh]">
          <MarkdownPreview
            source={content}
            className="text-white !bg-transparent w-full !border-white"
            rehypeRewrite={(node) => {
              if (
                node.type === "element" &&
                node.tagName !== "svg" &&
                node.tagName !== "a"
              ) {
                // check if child element is
                node.properties = {
                  class:
                    "text-white bg-transparent mx-2  !border-white",
                };
              }
            }}
          />
        </ScrollArea>
      )}
    </div>
  );
};

export default BlogContentPreviewComponent;
